package com.nonopn.skywatcher.common.app.pages.map.model.weather

import com.nonopn.skywatcher.common.app.pages.map.model.fake
import eu.codlab.weather.common.models.WeatherConditionAlertType
import korlibs.time.DateTime
import kotlinx.serialization.Serializable

@Serializable
data class ForecastCondensed(
    val timestamp: Long,
    val overhead: Boolean,
    val storm: Storm? = null,
    val lightning: Boolean,
    val tornadic: Boolean,
    val alert: String
) {
    fun actualAlert() = WeatherConditionAlertType.entries.find {
        it.name == alert
    }
}

@Serializable
data class WeatherResult(
    val errors: List<ErrorObject>,
    val condition: Condition,
    val conditions: List<Condition>,
    val threats: List<ThreatsPeriod>,
    val airQuality: List<AirQualityPeriod>,
    val forecasts: List<Forecast>,
    val condensed: ForecastCondensed? = null
) {
    fun currentForecastInterval(): Forecast? {
        val now = (DateTime.now().unixMillisLong / 1000)

        return forecasts.sortedByDescending { it.timestamp }
            .firstOrNull { it.timestamp < now }
    }

    companion object {
        fun fake(
            condition: Condition = Condition.fake,
            storm: Storm? = null,
            alert: WeatherConditionAlertType? = null,
            nextForecast: Forecast? = null,
        ) = WeatherResult(
            errors = emptyList(),
            condition = condition,
            conditions = listOf(condition),
            threats = emptyList(),
            airQuality = listOf(
                AirQualityPeriod(
                    0,
                    1,
                    "good",
                    "",
                    "",
                    "",
                    AirQualityHealth(
                        1,
                        "low",
                        "red"
                    ),
                    listOf(
                        AirQualityPollutant(
                            "type",
                            "no2",
                            1,
                            0.1f,
                            1,
                            PollutantCategory.Good,
                            "",
                            PollutantMethod.AirNow
                        )
                    )
                )
            ),
            forecasts = listOfNotNull(nextForecast),
            condensed = if (storm != null && alert != null) {
                ForecastCondensed(
                    timestamp = 0,
                    storm = storm,
                    overhead = false,
                    lightning = false,
                    tornadic = false,
                    alert = "alert"
                )
            } else {
                null
            }
        )
    }
}

@Serializable
data class ErrorObject(
    val code: String,
    val description: String
)